import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormControlLabel,
	Grid,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	Stack,
	TextField,
	Typography,
} from "@mui/material";

import { ValidateEmail } from "../Common/helpers";

export default function SellerByerOnboardingDialog({ state, onClose }) {
	console.log("SellerByerOnboardingDialog", state)
	const [complete, setComplete] = useState(false);
	const handleClose = () => {
		onClose();
	};
	const [formData, setFormData] = useState({});
	const handleChange2 = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value });
	};

	const manageSubmit = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				uid: state.uid,
				...formData,
			}),
		};
		fetch("/api/34ecfcb39e70401da24338d86945052f", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
		onClose();
	};
	useEffect(() => {
		if (window.location.href.startsWith("http://localhost") && formData.email === undefined) {
			setFormData({
				...formData,
				email: "guillaume.besse+bk" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
				firstname: "Guigui_1_" + Math.floor(Math.random() * 10000),
				lastname: "Besse_1_" + Math.floor(Math.random() * 10000),
				firstname2: "Guigui2 (PRXR)",
				lastname2: "Besse2",
				email2: "guillaume.besse+bk" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
				firstname3: "Guigui3 (LNKD)",
				lastname3: "Besse3",

				type: "PP",

				gender: undefined,
				proxier: undefined,
				union: undefined,
			});
		} else {
			setFormData({
				...formData,

				type: "PP",

				proxier: undefined,
				union: undefined,
			});
		}
	}, []);

	const [openSelect, setOpenSelect] = useState(false);
	const handleCloseSelect = () => {
		setOpenSelect(false);
	};

	const handleOpenSelect = () => {
		setOpenSelect(true);
	};
	const [openSelect1, setOpenSelect1] = useState(false);
	const handleCloseSelect1 = () => {
		setOpenSelect1(false);
	};

	const handleOpenSelect1 = () => {
		setOpenSelect1(true);
	};
	useEffect(() => {
		//console.log(formData);
		var block1 = false;
		switch (formData.type) {
			case "PP":
				block1 =
					ValidateEmail(formData.email) &&
					formData.firstname.length > 0 &&
					formData.lastname.length > 0 &&
					["M", "Mme"].includes(formData.gender);
				break;
			case "PM":
				block1 = formData.lastname.length > 0;
				break;
		}

		switch (formData.proxier) {
			case undefined:
				block1 = false;
				break;
			case "N":
				break;
			case "O":
				block1 =
					block1 &&
					ValidateEmail(formData.email) &&
					formData.firstname2.length > 0 &&
					formData.lastname2.length > 0 &&
					["M", "Mme"].includes(formData.gender2);
				break;
			default:
		}

		if (formData.type == "PP") {
			switch (formData.union) {
				case undefined:
					block1 = false;
					break;
				case "N":
					break;
				case "O":
					block1 = block1 && formData.firstname3.length > 0 && formData.lastname3.length > 0 && ["M", "Mme"].includes(formData.gender3);
					break;
				default:
			}
		}

		setComplete(block1);
	}, [formData]);
	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={state.open} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5">Inviter un propriétaire</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Grid container>
					<Grid item xs={12}>
						<div>
							<FormControl component="fieldset">
								<RadioGroup
									row
									aria-label="position"
									defaultValue={formData.type}
									name="type"
									onChange={handleChange2}
								>
									<FormControlLabel
										value="PP"
										control={<Radio color="primary" />}
										label="Le propriétaire est un particulier"
										labelPlacement="start"
										style="margin-left: 0px"
									/>
									<FormControlLabel value="PM" control={<Radio color="primary" />} label="Une société" labelPlacement="start" />
								</RadioGroup>
							</FormControl>
						</div>
						{formData.type === "PP" && (
							<div>
								<Grid container>
									<Grid item xs={4}>
										<FormControl component="fieldset">
											<RadioGroup
												row
												aria-label="gender"
												name="gender"
												defaultValue={formData.gender}
												onChange={handleChange2}
												dense
											>
												<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
												<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
											</RadioGroup>
										</FormControl>
									</Grid>
									<Grid item xs={8}>
										<TextField
											id="firstname"
											name="firstname"
											variant="outlined"
											style={{
												marginLeft: 0,
												marginRight: 0,
											}}
											placeholder="Prénom"
											fullWidth
											margin="dense"
											size="small"
											value={formData.firstname}
											onChange={handleChange2}
										/>

									</Grid>
								</Grid>
							</div>
						)}{" "}
						<div>
							<TextField
								id="lastname"
								name="lastname"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder={formData.type === "PM" ? "Raison sociale" : "Nom"}
								fullWidth
								margin="dense"
								size="small"
								value={formData.lastname}
								onChange={handleChange2}
							/>
						</div>
						<div>
							{formData.proxier === "N" && formData.type === "PP" && (
								<div>
									<TextField
										id="email"
										name="email"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Email"
										fullWidth
										margin="dense"
										size="small"
										value={formData.email}
										onChange={handleChange2}
									/>
								</div>
							)}
						</div>
						<div>
							<Stack flexDirection={"row"} spacing={1} justifyContent={"flex-start"} alignItems={"center"}>
								<Typography>
									{formData.type === "PP"
										? "Ce propriétaire est-il représenté par une autre personne ?"
										: "Cette société est représentée par"}
								</Typography>


								<Select
									labelId="proxier"
									id="proxier"
									name="proxier"
									open={openSelect}
									onClose={handleCloseSelect}
									onOpen={handleOpenSelect}
									value={formData.proxier}
									onChange={handleChange2}
									size="small"
									style="margin-left: 10px;"
								>
									{formData.type === "PP" && (
										<MenuItem value={"N"}>
											<em>Non</em>
										</MenuItem>
									)}
									<MenuItem value={"O"}>
										<em>{formData.type === "PP" ? "Oui, je l'inscris" : "Un nouveau participant"}</em>
									</MenuItem>
									{state.users &&
										state.users.map((u) => {
											return (
												<MenuItem value={u.uid}>
													{formData.type === "PP" ? "Oui, par " : ""}
													{u.name}
												</MenuItem>
											);
										})}
								</Select>

							</Stack>
							{["O"].includes(formData.proxier) && (
								<div>
									<div>
										<Typography>Si la personne n'est pas encore inscrite, nous allons l'inviter également</Typography>
										<div></div>
										<Grid container>
											<Grid item xs={4}>
												<FormControl component="fieldset">
													<RadioGroup
														row
														aria-label="gender2"
														name="gender2"
														//defaultValue={}
														onChange={handleChange2}
													>
														<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
														<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
													</RadioGroup>
												</FormControl>
											</Grid>
											<Grid item xs={8}>
												<TextField
													id="firstname2"
													name="firstname2"
													variant="outlined"
													style={{
														marginLeft: 0,
														marginRight: 10,
													}}
													placeholder="Prénom"
													fullWidth
													margin="dense"
													size="small"
													value={formData.firstname2}
													onChange={handleChange2}
												/>
											</Grid>
										</Grid>
									</div>
									<div>
										<TextField
											id="lastname2"
											name="lastname2"
											variant="outlined"
											style={{
												marginLeft: 0,
												marginRight: 10,
											}}
											placeholder="Nom"
											fullWidth
											margin="dense"
											size="small"
											value={formData.lastname2}
											onChange={handleChange2}
										/>
									</div>
								</div>
							)}
						</div>
						{formData.proxier === "O" && (
							<div>
								<TextField
									id="email"
									name="email"
									variant="outlined"
									style={{
										marginLeft: 0,
										marginRight: 10,
									}}
									placeholder="Email"
									fullWidth
									margin="dense"
									size="small"
									value={formData.email}
									onChange={handleChange2}
								/>
							</div>
						)}
					</Grid>
				</Grid>
				{formData.type === "PP" && (
					<Stack flexDirection={"row"} spacing={1} justifyContent={"flex-start"} alignItems={"center"}>
						<Typography>Ce propriétaire a-t'il un lien d'union une autre personne qui nécessite une inscription ?</Typography>


						<Select
							labelId="union"
							id="union"
							name="union"
							open={openSelect1}
							onClose={handleCloseSelect1}
							onOpen={handleOpenSelect1}
							value={formData.union}
							onChange={handleChange2}
							size="small"
							style="margin-left: 10px;"
						>
							{formData.type === "PP" && (
								<MenuItem value={"N"}>
									<em>Non</em>
								</MenuItem>
							)}
							<MenuItem value={"O"}>
								<em>{"Oui, je l'inscris"}</em>
							</MenuItem>
							{state.users &&
								state.users
									.filter((rec) => {
										return rec.tp === 1;
									})
									.map((u) => {
										return <MenuItem value={u.uid}>Oui, avec {u.name}</MenuItem>;
									})}
						</Select>

					</Stack>
				)}

				{formData.union === "O" && (
					<div>
						{" "}
						<div>
							<Grid container spacing={1}>
								<Grid item xs={2}>
									<FormControl component="fieldset">
										<RadioGroup
											row
											aria-label="gender3"
											name="gender3"
											//defaultValue="Mme"
											onChange={handleChange2}
										>
											<FormControlLabel value="Mme" control={<Radio color="primary" />} label="Mme" />
											<FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
										</RadioGroup>
									</FormControl>
								</Grid>
								<Grid item xs={5}>
									<TextField
										id="firstname3"
										name="firstname3"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Prénom"
										fullWidth
										margin="dense"
										value={formData.firstname3}
										onChange={handleChange2}
									/>
								</Grid>
								<Grid item xs={5}>
									<TextField
										id="lastname3"
										name="lastname3"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Nom"
										fullWidth
										margin="dense"
										value={formData.lastname3}
										onChange={handleChange2}
									/>
								</Grid>
							</Grid>
						</div>
						<div></div>
					</div>
				)}
			</DialogContent>
			<DialogActions>
				<Stack flexDirection={"row"} justifyContent={"space-between"} style="width: 100%">
					<Button variant="outlined" onClick={onClose}>
						Annuler
					</Button>
					<Button variant="contained" onClick={manageSubmit} disabled={!complete}>
						Ajouter
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
}
